import { fieldPoolIpV4YupValidation } from '@/shared/utils/validationSchema';
import * as yup from 'yup';


export const ipv4FormSchema = yup.object({
  grupo_ipv4: yup.string().required('El campo grupo IPV4 es requerido'),
  estado_ip: yup.string().required('El campo Estado de IP es requerido'),
  ip:  fieldPoolIpV4YupValidation.required('El campo IP es requerido'),
});
